import { Component, Input, OnInit, Output ,EventEmitter, AfterContentInit, OnChanges } from '@angular/core';
import { NoticeComponent } from 'src/app/home/news/notice/notice.component';



@Component({
  selector: 'app-admin-recruit-preview',
  templateUrl: './admin-recruit-preview.component.html',
  styleUrls: ['./admin-recruit-preview.component.css'],
})
export class AdminRecruitPreviewComponent implements OnChanges {


  @Input()
    notice:any;

  @Output()
    previewToggle:EventEmitter<boolean> =new EventEmitter();

    jobDescriptions:Array<String> = [];
    essentialSkills:Array<String> = [];
    extraSkills:Array<String> = [];

  date:Date =new Date();

  
  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges():void{
    this.jobDescriptions = this.notice.jobDescription.split('\n'); this.essentialSkills = this.notice.essentialSkill.split('\n'); this.extraSkills = this.notice.extraSkill.split('\n'); }

  unactivePreivew(){
    this.previewToggle.emit(false);
  }



}
